import React from 'react';
import FormHeader from '../../components/shared/form/formHeader';
import QuemEQuemList from '../../components/usuario/quemEQuem/quemEQuemList';

const QuemEQuem = () => (
  <div>
    <FormHeader titulo="Quem é Quem"/>
    <QuemEQuemList />
  </div>
);

export default QuemEQuem;
